
import React from 'react';
import { Box, Stack, styled, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import FooterTitle from './FooterTitle';
import FooterLink from './FooterLink';
import FooterLinkTwo from './FooterLinkTwo';
import FooterLinkThree from './FooterLinkThree';
import FooterLinkFour from './FooterLinkFour';
import FooterLinkFive from './FooterLinkFive';
import FooterLinkSix from './FooterLinkSix';
import FooterLinkSev from './FooterLinkSev';
import FooterLinkEight from './FooterLinkEight';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

const Footer = () => {
  const StackColumn = styled(Stack)(() => ({
    
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      gap: 7,
      textAlign: 'center',
      padding: '20px',
      height: 'fit-content',
      position: 'relative',
  }));

  const BoxRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#000000',
    color: '#fffff',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 30,
    }
  }));

  return (
    <BoxRow component="footer" sx={{ py: 4, px: 2 }}>
      
      <StackColumn>
      <>
        <br/>
        <br/>
        <h4 className='site-links'>Site Links</h4>
        <ul style={{
          marginBottom: '15px',
          lineHeight:'1',
          listStyle:'none',
          margin:'0px auto',
      fontSize: '7vw',
      fontWeight: '400',
      textDecoration: 'none',
      color: '#ffffff',
      textTransform: 'uppercase',
      padding:'0px',
      '@media (max-width:420px)': {
        fontSize: '8vw'      
        
      },
      "&:hover": {
        color: '#4dc548',
      }}}>
         <li className="ftrlist">
    <a href="/">Home</a>
  </li>
        
  <li className="ftrlist">
    <a href="/egress-kits.html">Egress Kits</a>
  </li>
  <li className="ftrlist">
    <a href="/egress-blog">Egress Blog</a>
  </li>
  <li className="ftrlist">
    <a href="/egress-kits.html">Egress Window Stories</a>
  </li>
  <li className="ftrlist">
    <a href="/egress-kits.html">Egress Window Videos</a>
  </li>
  <li className="ftrlist">
    <a href="/inswing-egress-window.html">Single Hung Inswing Egress Window</a>
  </li>
  <li className="ftrlist">
    <a href="/vinyl-egress-window-specs.html">Vinyl Egress Window Specs</a>
  </li>
  <li className="ftrlist">
    <a href="/casement-egress-window.html">Casement Egress Window</a>
  </li>
  <li className="ftrlist">
    <a href="/slider-window-specs.html">Slider Window Specs</a>
  </li>
  <li className="ftrlist">
    <a href="/quary-view-well-specs.html">Quary View Well Specs</a>
  </li>
  <li className="ftrlist">
    <a href="/stoneview-specs.html">StoneView Specs</a>
  </li>
  <li className="ftrlist">
    <a href="/window-well-cover-specs.html">Window Well Cover Specs</a>
  </li>
  <li className="ftrlist">
    <a href="/privacy-policy.html">Privacy Policy</a>
  </li>
  <li className="ftrlist">
    <a href="/sitemap.html">Sitemap</a>
  </li>
</ul>

        </>
        <FooterTitle text={'Product Specifications'}/>
        <FooterLink text={'Egress Kits'} />
        <FooterLinkTwo text={'Egress Window Blog'} />
        <FooterLinkThree text={'Inswing Egress Window'} />
        <FooterLinkFour text={'Crank-out Egress Window'} />
        <FooterLinkFive text={'Casement Egress Window'}/>
        <FooterLinkSix text={'Quarry View Window Well'}/>
        <FooterLinkSev text={'StoneView Window Well'}/>
        <FooterLinkEight text={'Window Well Cover'}/>
        
      </StackColumn>
      <>
      <div data-ux="Block" data-aid="FOOTER_SOCIAL_LINKS" class="x-el x-el-div c1-1 c1-2 c1-15 c1-17 c1-cg c1-ch c1-ci c1-4y c1-6x c1-cj c1-ck c1-b c1-c c1-d c1-e c1-f c1-g">
                        <a rel="noopener" role="link" aria-haspopup="true" data-ux="Link" target="_blank" data-aid="FOOTER_FACEBOOK_LINK" aria-label="Facebook Social Link" href="https://www.facebook.com/JacksonEgressWindows/" data-typography="LinkAlpha" class="x-el x-el-a c1-2c c1-2d c1-y c1-1c c1-1d c1-2e c1-z c1-cl c1-b c1-2k c1-c c1-2l c1-cm c1-cn c1-d c1-e c1-f c1-g" data-tccl="ux2.FOOTER.footer4.Layout.Default.Link.Default.130834.click,click"><svg viewBox="0 0 24 24" fill="#ffffff" width="40px" height="40px" data-ux="IconSocial" class="x-el x-el-svg c1-1 c1-2 c1-cb c1-26 c1-2t c1-3n c1-3o c1-3p c1-3q c1-b c1-c c1-d c1-e c1-f c1-g">
                            <path fill-rule="evenodd" d="M22 12.061C22 6.505 17.523 2 12 2S2 6.505 2 12.061c0 5.022 3.657 9.184 8.438 9.939v-7.03h-2.54v-2.91h2.54V9.845c0-2.522 1.492-3.915 3.777-3.915 1.094 0 2.238.197 2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 1.57v1.888h2.773l-.443 2.908h-2.33V22c4.78-.755 8.437-4.917 8.437-9.939z">
                            </path>
                          </svg></a><a rel="noopener" role="link" aria-haspopup="true" data-ux="Link" target="_blank" data-aid="FOOTER_YOUTUBE_LINK" aria-label="YouTube Social Link" href="https://www.youtube.com/channel/UCwWAUUv2-K0mFUgwYVGK8wA" data-typography="LinkAlpha" class="x-el x-el-a c1-2c c1-2d c1-y c1-1c c1-1d c1-2e c1-z c1-cl c1-b c1-2k c1-c c1-2l c1-cm c1-cn c1-d c1-e c1-f c1-g" data-tccl="ux2.FOOTER.footer4.Layout.Default.Link.Default.130835.click,click"><svg viewBox="0 0 24 24" fill="#ffffff" width="40px" height="40px" data-ux="IconSocial" class="x-el x-el-svg c1-1 c1-2 c1-cb c1-26 c1-2t c1-3n c1-3o c1-3p c1-3q c1-b c1-c c1-d c1-e c1-f c1-g">
                            <g transform="translate(2 2)">
                              <polygon points="8.811 11.495 11.927 9.88 8.807 8.255"></polygon>
                              <path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 10 0zm5.673 10.436c0 .935-.066 1.866-.066 1.866-.027.415-.17.814-.41 1.153-.306.308-.72.483-1.153.487-1.615.116-4.033.12-4.033.12s-2.99-.03-3.913-.117a1.91 1.91 0 0 1-1.25-.49 2.273 2.273 0 0 1-.419-1.146s-.033-.934-.033-1.865V9.56c0-.935.033-1.876.033-1.876s.03-.804.364-1.153c.305-.312.72-.493 1.156-.506 1.615-.116 4.036-.149 4.036-.149s2.411.033 4.026.15c.44.016.855.203 1.16.52.244.336.394.731.436 1.145 0 0 .07.934.07 1.865l-.004.88z">
                              </path>
                            </g>
                          </svg></a>
                      </div>
      </>

      
      <StackColumn className={"icons"}>
        <FooterTitle text={'Jackson Egress Windows'} />
        <Stack direction="row" width="90vw" maxWidth="800px" justifyContent="space-between">
          <Link
            href="https://instagram.com/jacksonegresswindows"
            variant="body2"
            sx={{
              color: '#ffffff',
              "&:hover": {
                color: '#4dc548',
              }
            }}
          >
            <InstagramIcon />
          </Link>
          <Link
            href="https://www.facebook.com/JacksonEgressWindows/"
            variant="body2"
            sx={{
              color: '#ffffff',
              "&:hover": {
                color: '#4dc548',
              }
            }}
          >
            <FacebookIcon />
          </Link>
          <Link
            href="https://www.youtube.com/watch?reload=9&v=J7Ob3d4GHG0"
            variant="body2"
            sx={{
              color: '#ffffff',
              "&:hover": {
                color: '#4dc548',
              }
            }}
          >
            <YouTubeIcon />
          </Link>
         
        </Stack>

        <Typography variant="inherit" component="p" sx={{fontSize: '14px'}}>
          Copyright&copy; 2023 All Rights Reserved
        </Typography>
      </StackColumn>      
    </BoxRow>
  );
};

export default Footer;


